var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"recent-searches-container"},[_vm._v(_vm._s(_vm.$t('recently_viewed'))+": "),_c('ul',{staticClass:"searchList"},_vm._l((_vm.getRecentlyViewedDocs),function(docs,index){return _c('li',{key:index},[_c('a',{staticClass:"linkname",attrs:{"href":docs.link,"title":docs.name}},[_vm._v(_vm._s(docs.name))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }